/**
 * Описание одного фиата
 */
export interface IFiat {
  id: number
  label: string
  symbol: string
}

/**
 * Описание лимитов для конкретной пары (например, "USD/BTC")
 */
export interface ILimit {
  code: string
  min: string
  max: string
}

/**
 * Общая структура ответа
 */
export interface IExchangeResponse {
  /**
   * Ключ: тип операции (например, "Buy").
   * Значение: объект, в котором ключ - пара (например, "USD/BTC"),
   * а значение - объект { [paymentId]: rate }.
   */
  courses: {
    [operationType: string]: {
      [pair: string]: {
        [paymentId: string]: string
      }
    }
  }

  /**
   * Платёжные методы по каждой паре.
   * Ключ: пара (например, "USD/BTC"),
   * значение: объект { [paymentId]: methodName }.
   */
  payments: {
    [pair: string]: {
      [paymentId: string]: string
    }
  }

  /**
   * Список названий криптовалют.
   */
  cryptocurrencies: string[]

  /**
   * Список фиатных валют с расширенной информацией.
   */
  fiats: IFiat[]

  /**
   * Баланс по каждой паре (ключ "USD/BTC" и т.п.).
   */
  balances: {
    [pair: string]: string
  }

  /**
   * Лимиты по каждой паре.
   * Ключ: пара (например, "USD/BTC"),
   * значение: объект лимита.
   */
  limits: {
    [pair: string]: ILimit
  }

  /**
   * Доступные способы оплаты (списком).
   */
  pay_methods: string[]

  /**
   * Доступные типы сделок (например, "Buy").
   */
  types: string[]
}

export class FormExchangeModel {
  payment_id = 0
  direction = ''
  from = ''
  to = ''
  fiat = ''
  currency = ''
  input = 'from'
}

export interface CalcRequest {
  to: string
  from: string
  sum_amount: string
  fee: string
  fee_network: number
  fee_code: string
}

export interface CurrencyDayCourse {
  from: string
  value: string
  old_value: string
  balances: number
  change: string
}

export type CurrencyDayFiat = Record<string, CurrencyDayCourse>

export interface CurrencyDayCourseResponse {
  stats: Record<string, CurrencyDayFiat>
}

export interface CurrencyCourse {
  code: string
  items: CurrencyDayCourse[]
}

export interface CalculateRequest {
  direction: string
  payment_id: number
  from?: string
  to?: string
}

export interface CalculateResultResponse {
  from: string // "150.00000000"
  to: string // "0.00115570"
  from_init: string // "150.00000000"
  to_init: string // "0.00000000"
  course_market: string // "99665.70000000"
  is_reverse: number // 0 (можно оставить number, если 0/1)
  fees: CalculateFeesResponse
  p: string // "2"
  course: number // 7.7046666666666659e-6
  sum_amount: number // 115.18364948999999
  sum_buy_withdraw: string // "0.00140570"
  commission_code: string // "USD"
  commission_all: string // "9.90000000"
  commission_direction: string // "4.80000000"
  commission_payment: string // "4.95000000"
  commission_payment_fixed: string // "0.15000000"
  commission_payment_all: string // "5.10000000"
  commission_network: number // 24.916425
  commission_direction_value: number // 3.2000000000000002
  commission_payment_value: number // 3.2999999999999998
  commission_payment_fixed_value: number // 0.14999999999999999
}

export interface CalculateFeesResponse {
  purchases_fixed: number // 0.10000000000000001
  withdraw_fixed: string // "0.00025000"
  withdraw_fixed_course: number // 24.916425
}

export interface CalculateResponse {
  to: string // "0.00115570"
  from: string // "150.00000000"
  sum_amount: string // "115.18364949"
  float_commission: number // 6.5
  base: number // 99665.699999999997
  fee: string // "9.90000000"
  fee_network: number // 24.916425
  fee_code: string // "USD"
  commission: string // "9.90000000"
  commission_code: string // "USD"
  result: CalculateResultResponse
  course: number // 7.7046666666666659e-6
}

export interface ICreateExchangeRequest {
  sum: string
  direction: string
  payment_id: number
}

export interface ICreateExchangeResponse {
  invoice_id: string
  transaction_id: number
}

export interface ChangeEmailRequest {
  email: string
}

export interface ChangeEmailCodeRequest {
  code: string
}

export class ChangeEmailModel {
  email = ''
}

export interface ChangeEmailResponse {
  error: boolean
  is_create?: boolean
  step?: string
  is_confirm_code?: number
  is_change?: boolean
  timer_days?: number
}

export interface ChangeEmailStatusResponse {
  error: boolean
  is_active: number

  change?: {
    created: Date
    step: string
    is_send: {
      '1': number
      '2': number
    }
    is_resend: {
      '1': number
      '2': number
    }
    is_confirm: {
      '1': number
      '2': number
    }
  }
  disabled_change?: number
  timer_days?: number
}
